import React from 'react';
import './StbButton.css';

export type StbButtonVariant = 'primary' | 'secondary' | 'danger' | 'outline' | 'ghost' | 'toggle';
export type StbButtonSize = 'sm' | 'md' | 'lg';

export interface StbButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  variant?: StbButtonVariant | (string & {});
  size?: StbButtonSize;
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  block?: boolean;
  icon?: boolean;
}

const StbButton = React.forwardRef<HTMLButtonElement, StbButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      type = 'button',
      loading = false,
      block = false,
      icon = false,
      disabled,
      className,
      children,
      ...rest
    },
    ref
  ) => {
    const classes = [
      'stb-btn',
      `stb-btn-${variant}`,
      size !== 'md' ? `stb-btn-${size}` : '',
      block ? 'stb-btn-block' : '',
      icon ? 'stb-btn-icon' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        ref={ref}
        type={type}
        className={classes}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        {...rest}
      >
        {loading && <span className="stb-btn-spinner" aria-hidden="true" />}
        <span className={loading ? 'stb-btn-label is-loading' : 'stb-btn-label'}>
          {children}
        </span>
      </button>
    );
  }
);

StbButton.displayName = 'StbButton';

export default StbButton;
